import { Row } from '@/components'
import { Breakpoint } from '@/enums'
import { themeBreakpointDown, toThemePixels } from '@/utils'
import styled from 'styled-components'

export const PageActions = styled(Row)`
  margin-top: ${toThemePixels(8)};
  gap: ${toThemePixels(2)};
  justify-content: space-between;
  ${themeBreakpointDown(Breakpoint.sm)} {
    margin-top: ${toThemePixels(4)};
    flex-wrap: wrap-reverse;
    justify-content: center;
    button {
      width: 100%;
    }
  }
`

export const PageTitle = styled.div`
  margin-bottom: ${toThemePixels(8)};
`
